import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import BottomNav from '../components/BottomNav';
import { useLang } from '../LangContext';
import { useT } from '../i18n';
import { getMember } from '../api';

const STATS = [
  { labelKey: 'statCoupons',    value: '5'    },
  { labelKey: 'statFreeDrinks', value: '2'    },
  { labelKey: 'statBadgeLevel', value: 'LV 4' },
  { labelKey: 'statFavorites',  value: '18'   },
];

const SETTINGS = [
  { labelKey: 'orderHistory',    descKey: 'orderHistoryDesc',    icon: 'receipt' },
  { labelKey: 'myCoupons',       descKey: 'myCouponsDesc',       icon: 'coupon'  },
  { labelKey: 'paymentMethods',  descKey: 'paymentMethodsDesc',  icon: 'payment' },
  { labelKey: 'notifSettings',   descKey: 'notifSettingsDesc',   icon: 'notif'   },
];

function SettingIcon({ type }) {
  const icons = {
    receipt: <path d="M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z"/>,
    coupon:  <path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"/>,
    payment: <path d="M20 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>,
    notif:   <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>,
  };
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="#b02600">
      {icons[type]}
    </svg>
  );
}

export default function ProfileScreen() {
  const navigate = useNavigate();
  const { lang } = useLang();
  const t = useT(lang);

  const [member, setMember] = useState(null);
  useEffect(() => { getMember().then(setMember).catch(console.error); }, []);

  const memberName = member?.name || t('profileName');
  const memberPoints = member?.points ?? 0;

  return (
    <div style={{
      backgroundColor: '#f8f5ff',
      minHeight: '100dvh',
      paddingTop: 56,
      paddingBottom: 100,
      fontFamily: "'Be Vietnam Pro', sans-serif",
      color: '#2d2d42',
    }}>
      <TopBar />

      <div style={{ maxWidth: 520, margin: '0 auto', padding: '0 16px' }}>

        {/* ── Profile Hero ─────────────────────────── */}
        <section style={{
          marginTop: 20,
          position: 'relative', overflow: 'hidden',
          borderRadius: 24, backgroundColor: '#b02600',
          padding: '28px 24px', color: '#ffffff',
          marginBottom: 20,
        }}>
          {/* Decorative orbs */}
          <div style={{
            position: 'absolute', top: -48, right: -48,
            width: 192, height: 192,
            backgroundColor: '#ff7857', borderRadius: '50%', opacity: 0.2,
          }}/>
          <div style={{
            position: 'absolute', bottom: -32, left: -32,
            width: 128, height: 128,
            backgroundColor: '#f9cc61', borderRadius: '50%', opacity: 0.1,
          }}/>

          <div style={{
            position: 'relative', zIndex: 1,
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20,
          }}>
            {/* Avatar */}
            <div style={{ position: 'relative' }}>
              <div style={{
                width: 88, height: 88, borderRadius: '50%',
                border: '4px solid rgba(255,255,255,0.2)',
                overflow: 'hidden', boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
                backgroundColor: '#ff7857',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 36,
              }}>🧋</div>
              <div style={{
                position: 'absolute', bottom: 0, right: 0,
                backgroundColor: '#f9cc61', color: '#443100',
                width: 26, height: 26, borderRadius: '50%',
                border: '2px solid #b02600',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
              }}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
              </div>
            </div>

            {/* Name + tier */}
            <div style={{ textAlign: 'center' }}>
              <h1 style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 700, fontSize: 22, color: '#ffffff', marginBottom: 6,
              }}>{memberName}</h1>
              <div style={{
                display: 'inline-flex', alignItems: 'center', gap: 6,
                backgroundColor: 'rgba(255,255,255,0.1)',
                padding: '4px 12px', borderRadius: 9999,
                backdropFilter: 'blur(8px)',
              }}>
                <span style={{
                  fontSize: 11, fontWeight: 700, color: '#f9cc61',
                  textTransform: 'uppercase', letterSpacing: '0.08em',
                }}>{t('goldMember')}</span>
              </div>
              <p style={{ marginTop: 10, fontSize: 13, opacity: 0.9, fontWeight: 500 }}>
                {memberPoints.toLocaleString()} {t('bubblePoints')}
              </p>
            </div>

            {/* Edit button */}
            <button style={{
              backgroundColor: '#FF5C36', color: '#ffffff',
              border: 'none', borderRadius: 12,
              padding: '10px 20px',
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 700, fontSize: 13, cursor: 'pointer',
              display: 'flex', alignItems: 'center', gap: 6,
              boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
            }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
              </svg>
              {t('editProfile')}
            </button>
          </div>
        </section>

        {/* ── Stats bento grid ─────────────────────── */}
        <section style={{
          display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 10,
          marginBottom: 24,
        }}>
          {STATS.map(({ labelKey, value }) => (
            <div key={labelKey} style={{
              backgroundColor: '#f2efff',
              borderRadius: 16, padding: '14px 8px',
              display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
            }}>
              <span style={{
                fontSize: 9, fontWeight: 700, color: '#75748d',
                textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4,
              }}>{t(labelKey)}</span>
              <span style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 800, fontSize: 18, color: '#b02600',
              }}>{value}</span>
            </div>
          ))}
        </section>

        {/* ── Settings list ────────────────────────── */}
        <section style={{ marginBottom: 28 }}>
          <h2 style={{
            fontSize: 11, fontWeight: 700, color: '#75748d',
            textTransform: 'uppercase', letterSpacing: '0.1em',
            padding: '0 16px', marginBottom: 14,
          }}>{t('accountSettings')}</h2>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {SETTINGS.map(({ labelKey, descKey, icon }) => (
              <button
                key={labelKey}
                onClick={() => {}}
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  padding: '16px 20px',
                  backgroundColor: '#f2efff',
                  borderRadius: 16, textDecoration: 'none',
                  border: 'none', width: '100%', cursor: 'pointer',
                  transition: 'background 0.15s',
                }}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = '#e8e5ff'}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = '#f2efff'}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                  <div style={{
                    width: 40, height: 40, borderRadius: 12,
                    backgroundColor: '#ffffff',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    boxShadow: '0 2px 8px rgba(45,45,66,0.06)',
                  }}>
                    <SettingIcon type={icon}/>
                  </div>
                  <div>
                    <p style={{
                      fontFamily: "'Be Vietnam Pro', sans-serif",
                      fontWeight: 600, fontSize: 14, color: '#2d2d42', marginBottom: 2,
                    }}>{t(labelKey)}</p>
                    <p style={{ fontSize: 11, color: '#75748d' }}>{t(descKey)}</p>
                  </div>
                </div>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="#75748d">
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                </svg>
              </button>
            ))}
          </div>
        </section>

        {/* ── Logout ───────────────────────────────── */}
        <section style={{ padding: '0 0 16px' }}>
          <button
            onClick={() => navigate('/')}
            style={{
              width: '100%',
              backgroundColor: '#f2efff',
              border: '1px solid rgba(180,19,64,0.1)', color: '#b41340',
              borderRadius: 16, padding: '14px',
              fontFamily: "'Be Vietnam Pro', sans-serif",
              fontWeight: 700, fontSize: 14, cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              transition: 'background 0.15s',
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(180,19,64,0.05)'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#f2efff'}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
            </svg>
            {t('logOut')}
          </button>

          <p style={{ marginTop: 20, textAlign: 'center', fontSize: 11, color: '#75748d' }}>
            {t('version')}
          </p>
        </section>

      </div>

      <BottomNav />
    </div>
  );
}
